/* eslint import/prefer-default-export: ["off"] */
export const SET_USER = 'SET_USER';
export const SET_ROOT = 'SET_ROOT';
export const SET_HAS_LOGGED_OUT = 'SET_HAS_LOGGED_OUT';
export const SET_ROLE = 'SET_ROLE';
